<div
  class="tw-bottom-1 tw-col-span-full sm:tw-col-span-7 md:tw-col-span-5 md:tw-col-start-2 lg:tw-col-span-8 lg:tw-col-start-2 xl:tw-col-span-6 xl:tw-col-start-3"
>
  <div
    class="tw-group tw-relative tw-z-0 tw-w-full"
    [ngClass]="{ 'has-error': !!isInvalid }"
  >
    <input
      #textInput
      [type]="inputType"
      [id]="inputId"
      (input)="onInputChange($event)"
      (focus)="onFocus($event)"
      (blur)="onTouched($event)"
      (change)="handleEvent('change', $event)"
      [required]="required"
      [attr.aria-invalid]="!!isInvalid"
      [attr.aria-describedby]="
        inputId +
        '-readonly ' +
        inputId +
        '-error ' +
        inputId +
        '-helper' +
        ' ' +
        describedByIds
      "
      class="group-[.has-error]:[&amp;:not(:focus)]:tw-pr-6 focus:[&amp;:not(:placeholder-shown)]:tw-pr-6 group-hover:[&amp;:not(:placeholder-shown)]:tw-pr-6 tw-peer tw-mt-4 tw-block tw-w-full tw-cursor-text tw-appearance-none tw-border-0 tw-border-b-2 tw-border-neutral-200 tw-bg-transparent tw-px-0 tw-py-1 tw-text-neutral-800 tw-placeholder-neutral-600 placeholder:tw-opacity-0 read-only:tw-cursor-not-allowed read-only:tw-border-dashed read-only:tw-bg-neutral-100 focus:tw-border-blue-800 focus:tw-outline-none focus:tw-ring-0 focus:placeholder:tw-opacity-100 group-[.has-error]:tw-border-red-200 group-[.has-error]:tw-text-red-800 group-[.has-error]:tw-placeholder-red-800 focus:group-[.has-error]:tw-border-red-800 dark:tw-border-neutral-700 dark:tw-text-neutral-100 dark:tw-placeholder-neutral-400 dark:read-only:tw-bg-neutral-800 dark:focus:tw-border-blue-600 dark:group-[.has-error]:tw-border-red-700 dark:group-[.has-error]:tw-text-red-100 dark:group-[.has-error]:tw-placeholder-red-400 dark:focus:group-[.has-error]:tw-border-red-700"
      [ngClass]="{
        'tw-text-base': size === 'normal',
        'tw-text-3xl tw-font-bold placeholder:tw-font-bold': size === 'large',
      }"
      [placeholder]="labelText"
      [maxLength]="maxLength"
      [attr.readonly]="readonly ? true : null"
      [value]="value"
    />
    <button
      type="button"
      *ngIf="!readonly"
      (click)="resetField($event)"
      [class.tw-hidden]="!showResetButton"
      class="tw-dark:text-neutral-300 tw-absolute tw-right-0 tw-z-10 tw-hidden tw-items-center focus:tw-flex peer-focus:peer-[&:not(:placeholder-shown)]:peer-[&:not(:read-only)]:tw-flex group-hover:peer-enabled:peer-[&:not(:placeholder-shown)]:peer-[&:not(:read-only)]:tw-flex"
      [ngClass]="{
        'tw-top-3': size === 'normal',
        'tw-top-6': size === 'large',
      }"
      [attr.aria-labelledby]="inputId + '-clear ' + inputId + '-label'"
    >
      <da-icon
        name="close"
        type="solid"
        icon="x-mark"
        [solidSize]="16"
        [className]="'tw-size-4'"
      />
      <span class="tw-sr-only" [id]="inputId + '-clear'">
        {{ resetButtonLabel }}
      </span>
    </button>
    <da-icon
      *ngIf="readonly"
      name="lock"
      type="solid"
      icon="lock-closed"
      [solidSize]="16"
      class="tw-pointer-events-none tw-absolute tw-right-0 tw-flex tw-items-center tw-text-neutral-600"
      [ngClass]="{
        'tw-top-2': size === 'normal',
        'tw-top-3': size === 'large',
      }"
      [className]="'tw-size-4'"
    />
    <label
      [for]="inputId"
      [id]="inputId + '-label'"
      [ngClass]="{
        'tw-text-base peer-placeholder-shown:tw-text-base peer-placeholder-shown:tw-font-normal':
          size === 'normal',
        'tw-text-3xl tw-font-bold peer-placeholder-shown:tw-text-3xl peer-placeholder-shown:tw-font-bold':
          size === 'large',
      }"
      class="tw-absolute tw-top-1 tw-origin-[0] -tw-translate-y-5 tw-transform tw-cursor-text tw-text-xs tw-text-neutral-600 tw-duration-300 group-hover:tw-text-neutral-800 group-[.has-error]:tw-text-red-800 group-hover:group-[.has-error]:tw-text-red-800 peer-placeholder-shown:tw-translate-y-0 peer-placeholder-shown:tw-text-base peer-read-only:tw-cursor-not-allowed peer-focus:tw-left-0 peer-focus:-tw-translate-y-5 peer-focus:tw-text-xs peer-focus:tw-font-bold peer-focus:tw-text-blue-800 group-[.has-error]:peer-focus:tw-text-red-800 dark:tw-text-neutral-300 dark:group-hover:tw-text-neutral-200 dark:group-[.has-error]:tw-text-red-400 dark:group-hover:group-[.has-error]:tw-text-red-300 dark:peer-focus:tw-text-blue-600 dark:group-[.has-error]:peer-focus:tw-text-red-400"
    >
      {{ labelText }}
      <span *ngIf="required" aria-hidden="true" class="tw-text-red-800">
        *
      </span>
    </label>
    <span *ngIf="readonly" class="tw-sr-only" [id]="inputId + '-readonly'">{{
      readonlyDescription
    }}</span>
    <div
      *ngIf="helperText"
      [id]="inputId + '-helper'"
      class="tw-mt-1 tw-text-xs tw-text-neutral-600"
    >
      {{ helperText }}
    </div>
    <div
      [id]="inputId + '-error'"
      class="tw-mt-1 tw-text-xs tw-text-red-800"
      role="alert"
    >
      <div *ngFor="let error of errors">
        <span *ngIf="isInvalid && error.name">{{ error.message }}</span>
      </div>
    </div>
  </div>
</div>
